import { all, takeEvery, put, call } from "@redux-saga/core/effects";
import { AnyAction } from "redux";
import { ActionResponseType } from "../../../common/types/common.types";
import { ReportViewerType } from "../../../components/ReportViewer/ReportViewer.types";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import dayjs from "dayjs";
import store from "../../../core/store/index";
import { GET_LOCATION_REPORT_DATA } from "./LocationReport.actions";
import getLocationReport from "./LocationReport.api";
import { locationReportReducerActions } from "./LocationReport.reducer";

const excelWorkerLocationReport: Worker = new Worker(
  new URL("./ExcelWorkerLocationReport.ts", import.meta.url)
);

excelWorkerLocationReport.onmessage = (event) => {
  const excelData = event.data.buffer;

  //Handle the Excel data here, for example, you can save it as a file
  const blob = new Blob([excelData], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  let downloadFileName = `Location - ${event.data.data.SiteCode} - ${event.data.data.Name} - ${dayjs(new Date()).format(
    "DD-MMM-YYYY HH_mm"
  )}`;
  const extension = getFileExtensionFromMimeType(blob.type);
  if (extension !== null && extension !== "") {
    if (!downloadFileName.endsWith(extension)) {
      downloadFileName += extension;
    }
  }
  // Create a download link for the Excel file and trigger the download
  const a = document.createElement("a");
  a.href = url;
  a.download = downloadFileName;
  a.click();

  window.URL.revokeObjectURL(url);
  store.dispatch(
    locationReportReducerActions.setDownloadStatus(false)
  );
  store.dispatch(
    openPopup({
      Open: true,
      BodyText: "Report downloaded successfully!",
      HeaderText: "Success", //"Success",
      PopupType: EnumPopupType.SuccessPopup,
    } as PopupProps)
  );

  return () => {
    excelWorkerLocationReport.terminate();
  };
};

const locationReportWatcher = function* () {
  yield takeEvery(
    GET_LOCATION_REPORT_DATA,
    function* (action: AnyAction): any {
      const data = action.payload as ReportViewerType;

      try {
        const result: ActionResponseType = yield call(() =>
        getLocationReport(data)
        );
        if (result.IsSuccess) {
          const workerObj = {
            data: result.Data,
          };
          excelWorkerLocationReport.postMessage(workerObj);
        } else {
          store.dispatch(
            locationReportReducerActions.setDownloadStatus(false)
          );
          yield put(
            openPopup({
              Open: true,
              BodyText:
                "Sorry, An error occured while generating the excel report!",
              HeaderText: "Warning",
              PopupType: EnumPopupType.WarningPopup,
              OkBtnClick() {},
            } as PopupProps)
          );
        }
      } catch {
        store.dispatch(
            locationReportReducerActions.setDownloadStatus(false)
        );
        yield put(
          openPopup({
            Open: true,
            BodyText:
              "Sorry, An error occured while generating the excel report!",
            HeaderText: "Warning",
            PopupType: EnumPopupType.WarningPopup,
            OkBtnClick() {},
          } as PopupProps)
        );
      }
    }
  );
};

const getFileExtensionFromMimeType = (mimeType) => {
  const mimeTypesToExtensions = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      ".xlsx",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      ".docx",
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
  };
  return mimeTypesToExtensions[mimeType] || "";
};
const locationReportSaga = function* () {
  yield all([locationReportWatcher()]);
};

export default locationReportSaga;
